import markdownToHtmlStringUtil from 'utils/string/markdown-to-html/index.js'
import { ARTICLE_MARKDOWN_REGEX } from 'modules/articles/constants/index.js'

export default function getChunkMarkdownObjUtil (chunk) {
  let chunkMarkdown = markdownToHtmlStringUtil(chunk || '')

  if (
    !chunkMarkdown.includes('id=') ||
    chunkMarkdown.includes('h1')
  ) {
    return {
      chunkMarkdown
    }
  }

  const re = new RegExp(
    ARTICLE_MARKDOWN_REGEX.TITLE_ID_ANCHOR
  )
  const resArr = re.exec(chunkMarkdown)
  if (!resArr) {
    return {
      chunkMarkdown
    }
  }

  const chunkAnchorMarkdown = resArr[0].replace(/\n+/g, '')
  const id = resArr[2]

  chunkMarkdown = chunkMarkdown.replace(chunkAnchorMarkdown, '')

  return {
    chunkMarkdown: chunkMarkdown.replace(/\n+/g, ''),
    chunkAnchorMarkdown: chunkAnchorMarkdown.replace(/\n+/g, ''),
    chunkAnchorId: id
  }
}
